var path = 'views/validators/edit/ExternalValidator.html';
var html = "<fd-external-data-source properties=models.newValidationRule.settings models=models></fd-external-data-source> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;